// @ts-nocheck


import notification from 'antd/lib/notification';
import * as Leaflet from 'leaflet';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import { geocode, getCurrentPosition, MAPBOX_API_KEY } from '../../lib/gis';



const LeafletBox = { height: 264, width: '100%', minWidth: 600 }; // для лифлета нужна явная высота
const bboxKey = 'bbox';













/*
  Рисует кнопку, по нажатию которой открывается модалкой с картой
  Пользователь может выбрать точку на карту, по координатам с помощью реверсивного
  геокодинга будет найден адрес. Когда пользователь жмет ок, вызывается функция колбэк с выбранным вейпойнтом
 */
class WaypointPicker extends React.Component {
  state = {
    modalVisible: false,
    waypoint: this.props.waypoint,
    isLoading: false,
    bbox: localStorage.getItem(bboxKey)
  };

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.waypoint, this.props.waypoint)) {
      this.setState({
        waypoint: this.props.waypoint
      });
    }
  }

  async componentDidMount() {
    if (!localStorage.getItem(bboxKey)) {
      try {
        const {
          coords: { latitude, longitude }
        } = await getCurrentPosition();
        const bbox = Leaflet.latLng(latitude, longitude).
        toBounds(500).
        toBBoxString();
        localStorage.setItem(bboxKey, bbox);
      } catch {
        notification.error({
          message: 'Не удалось определить ваше местоположение'
        });
      }
    }
  }

  onMapClick = async (event) =>

  {
    // Когда пользователь кликает на точку карты, мы получаем координаты Let + Long
    // Перевод координат в адрес называется обратным геокодингом, для это используется
    // сервис Google maps platform и в этом методе он и вызывается
    const { lat, lng } = event.latlng;

    localStorage.setItem(bboxKey, event.latlng.toBounds(500).toBBoxString());

    let address = '';

    this.setState(
      (state, props) => {
        return {
          isLoading: true,
          waypoint: {
            ...state.waypoint,
            address,
            latitude: lat,
            longitude: lng,
            radius: 1
          }
        };
      },
      async () => {
        try {
          address = await geocode(lat, lng);
        } catch (error) {
          address = 'Ошибка. Не удалось определить адрес точки.';
        } finally {
          this.setState(
            {
              isLoading: false,
              // $FlowFixMe
              waypoint: {
                ...this.state.waypoint,
                address,
                name: address
              }
            },
            () => {
              this.props.onPickWaypoint(this.state.waypoint);
            }
          );
        }
      }
    );
  };

  render() {
    return (
      <div>
        <div className="leaflet-container" style={LeafletBox}>
          <Map
            onMapClick={this.onMapClick}
            bbox={this.state.bbox}
            waypoint={this.state.waypoint || {}} />

        </div>
      </div>);

  }
}

/*
  Подписывается на клик по карте и центрирует карту на точке,
  если она вне видимой области. MapContainer в react-leaflet 4 применяет
  center/zoom только при монтировании и не поддерживает eventHandlers.
 */
const MapController = ({ onMapClick, latitude, longitude }) => {
  const map = useMap();
  useMapEvents({ click: onMapClick });

  React.useEffect(() => {
    if (!latitude || !longitude) return;
    const point = Leaflet.latLng(latitude, longitude);
    if (!map.getBounds().contains(point)) {
      map.panTo(point);
    }
  }, [map, latitude, longitude]);

  return null;
};

/*
  Компонент врапает лифлетовскую карту
 */
const Map = ({
  onMapClick,
  waypoint,
  bbox




}) => {
  const isValidWaypoint =
  !isEmpty(waypoint) && !!waypoint.latitude && !!waypoint.longitude;

  /**
   * Конвертирует bbox строку в bounds
   * @param bbox Строка вида 'southwest_lng,southwest_lat,northeast_lng,northeast_lat'
   */
  function convertBBoxToBounds(bbox) {
    if (bbox) {
      const bboxArray = bbox.split(',');
      return Leaflet.latLngBounds(
        [bboxArray[1], bboxArray[0]],
        [bboxArray[3], bboxArray[2]]
      );
    }
  }

  const center = isValidWaypoint ?
  [waypoint.latitude, waypoint.longitude] :
  [55.791278, 49.115734];

  return (
    <MapContainer
      bounds={isValidWaypoint ? null : convertBBoxToBounds(bbox)}
      style={LeafletBox}
      center={center}
      zoom={14}>

      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
        url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
        id="mapbox/streets-v11"
        accessToken={MAPBOX_API_KEY} />

      <MapController
        onMapClick={onMapClick}
        latitude={isValidWaypoint ? waypoint.latitude : null}
        longitude={isValidWaypoint ? waypoint.longitude : null} />
      {isValidWaypoint &&
      <Marker position={[waypoint.latitude, waypoint.longitude]} />
      }
    </MapContainer>);

};
export default WaypointPicker;
